module.exports = __webpack_public_path__ + "img/joburg-super-kings-logo-icon.6e850119.png";